<template>
  <div id="shade2" v-if="working">
    <LoaderView :show="working"/>
  </div>
  <energy-header :bookingCount="bookingCount" :key="energyRefresh" />
  <p id="month" class="hiddenInMobileView">{{ getMonth() }}</p>
  <div id="calendar-grid">
    <!--header with weekdays-->
    <div class="weekday-name">Mo</div>
    <div class="weekday-name">Di</div>
    <div class="weekday-name">Mi</div>
    <div class="weekday-name">Do</div>
    <div class="weekday-name">Fr</div>
    <!--days of the calendar-->
    <template  v-for="(element, index) in JSON.parse(JSON.stringify(calendar))" :key="index">
      <div :class="`day-div weekday-${index} ${isToday(element.date)} ${isBeforeToday(element.date)}`" @click="isBeforeToday(element.date) != 'beforeToday' && openBookingModal(element, index)" :disabled="isBeforeToday(element.date)=='beforeToday'">
        <span><span class="hiddenInDestopView">{{ weekDay(element.date) }} </span> {{ element.date.split("-")[0] }}<span class="hiddenInDestopView">.{{ Number(element.date.split("-")[1]) +1 }}.</span></span>
        <!--buttons with color indications for state of bookings-->
        <div v-if="element.am < maxSpaces" class="free time-button"><p> {{(maxSpaces - element.am)}} Frei</p></div>
        <div v-if="element.am > maxSpaces" class="booked time-button"><p>Gebucht</p></div>
        <div v-if="element.am === maxSpaces" class="full time-button"><p>Voll</p></div>
        
        <div v-if="element.pm < maxSpaces" class="free time-button"><p> {{(maxSpaces - element.pm)}} Frei</p></div>    
        <div v-if="element.pm > maxSpaces" class="booked time-button"><p>Gebucht</p></div>
        <div v-if="element.pm === maxSpaces" class="full time-button"><p>Voll</p></div>  
      </div>
    </template>
  </div>
  <booking-modal
    v-if="clickedDay !== NaN && openModal"
    :dayPackage="clickedDay"
    :bookingCount="bookingCount"
    @closemodal="closeAndReload"
    @refresh="refreshcounter++"
    :key="refreshcounter" 
  />
</template>

<script>
import BookingModal from "./BookingModal.vue";
import EnergyHeader from "./EnergyHeader.vue";
import { getFunctions, httpsCallable } from "firebase/functions";
import { firebase, region } from "../plugins/firebase";
import LoaderView from "./LoaderView.vue"

export default {
  name: "CalendarView",
  components: {
    BookingModal,
    EnergyHeader,
    LoaderView,
  },
  data() {
    return {
      calendar: [],
      clickedDay: NaN,
      openModal: false,
      dayStacker: NaN,
      maxSpaces: 4,
      bookingCount: 20,
      energyRefresh: 0,
      refreshcounter: 0,
      working: true,
    };
  },
  methods: {
    closeAndReload() {
      // reload data after closing modal
      this.openModal = false;
      this.buildCalendar();
    },
    buildCalendar() {
      // retrieves current data
      const addMessage = httpsCallable(getFunctions(firebase, region), "getMonthData");
      addMessage({})
      .then((result) => {
        //max bookings per user
        this.bookingCount = 20;
        result.data.forEach((item) => {
          // if bookings, max bookings decrease
          if (item.am === 1000) this.bookingCount--;
          if (item.pm === 1000) this.bookingCount--;
        });
        this.calendar = result.data;
        this.energyRefresh++;
        this.working = false
      })
      .catch(err=>{
        console.log(err)
        this.working = false
      })
    },
    getMonth() {
      // get the name of the month
      let monthNum = new Date().getMonth();
      const dayNum = new Date().getDate();
      if (dayNum >= 24) monthNum++;
      let month = "Dieser Monat";

      switch (monthNum) {
        case 0:
          month = "Januar";
          break;
        case 1:
          month = "Februar";
          break;
        case 2:
          month = "März";
          break;
        case 3:
          month = "April";
          break;
        case 4:
          month = "Mai";
          break;
        case 5:
          month = "Juni";
          break;
        case 6:
          month = "Juli";
          break;
        case 7:
          month = "August";
          break;
        case 8:
          month = "September";
          break;
        case 9:
          month = "Oktober";
          break;
        case 10:
          month = "November";
          break;
        case 11:
          month = "Dezember";
          break;
        case 12:
          month = "Januar";
          break;
        default:
          month = "Dieser Monat";
          break;
      }

      return month;
    },
    isToday(dateString) {
      const date = new Date();
      const newDay = date.getDate();
      const newMonth = date.getMonth();
      const newYear = date.getFullYear();
      const newDateString = String(newDay) + "-" + String(newMonth) +
      "-" + String(newYear);
      return newDateString === dateString ? "today" : "";
    },
    isBeforeToday(dateString) {
      const dateStringSplited = dateString.split("-");
      if(dateStringSplited[0] < 10) dateStringSplited[0] = `0${dateStringSplited[0]}`
      dateStringSplited[1] = Number(dateStringSplited[1]) + 1
      dateStringSplited[1] = dateStringSplited[1] < 10 ? `0${dateStringSplited[1]}` : dateStringSplited[1];
      const dateStringForJs = `${dateStringSplited[2]}-${dateStringSplited[1]}-${dateStringSplited[0]}`;
      const date = new Date(dateStringForJs);
      const Today = new Date()
      const isBeforeToday = date < Today && !this.isToday(dateString)
      console.log(dateStringForJs, "dateStringForJs")
      console.log(date, "date")
      console.log(Today, "Today")
      console.log(dateString, isBeforeToday)
      return isBeforeToday ? "beforeToday" : "";
    },
    openBookingModal(dayPackage, day) {
      // shows booking modal and prepares properties
      this.clickedDay = {
        package: dayPackage,
        weekday: day,
      };
      this.openModal = true;
    },
    weekDay(dateString){
      const weekdays = ["Mo.", "Di.", "Mi.", "Do.", "Fr."]
      const dateStringSplited = dateString.split("-");
      if(dateStringSplited[0] < 10) dateStringSplited[0] = `0${dateStringSplited[0]}`
      dateStringSplited[1] = Number(dateStringSplited[1]) + 1
      const dateStringForJs = `${dateStringSplited[2]}-${dateStringSplited[1]}-${dateStringSplited[0]}`;
      const date = new Date(dateStringForJs);
      return weekdays[date.getDay()-1]
    }
  },
  mounted() {
    // gets data before mount of calendar
    this.buildCalendar();
  },
};
</script>

<style scoped>
#month {
  z-index: 499;
  margin: 50px 15px;
  position: relative;
  top: 25px;
  font-size: 32px;
  font-weight: bold;
  text-align: start;
}

#calendar-grid {
  display: grid;
  grid: auto-flow / 1fr 1fr 1fr 1fr 1fr ;
}
.weekday {
  display: none;
}
.weekday-name {
  font-size: 1.25em;
  width: 140px;
  margin-left: 20px;
  text-align: start;
  color: #707070;
}

.day-div {
  border: 1px solid rgb(200, 200, 200);
  border-radius: 12.5px;
  margin: 10px;
  position: relative;
}

.weekday-5,
.weekday-6,
.weekday-12,
.weekday-13,
.weekday-19,
.weekday-20,
.weekday-26,
.weekday-27 {
  background-color: #f8f8f8;
  display: none;
}

.weekday-5 .free,
.weekday-6 .free,
.weekday-12 .free,
.weekday-13 .free,
.weekday-19 .free,
.weekday-20 .free,
.weekday-26 .free,
.weekday-27 .free {
  background-color: transparent;
}

.today {
  border-color: #4089c9;
  border-width: 2px;
  margin: 9px 9px;
  cursor: pointer;
}

.day-div:hover {
  border-color: #939393;
  border-width: 2px;
  margin: 9px 9px;
  cursor: pointer;
}

.day-div:hover>span,
.today>span {
  color: #4089c9;
}

.day-div>span {
  position: absolute;
  color: #777777;
  font-size: 1.3em;
  top: 6px;
  right: 5px;
  font-weight: 500;
}

.time-button {
  width: 100%;
  height: 40px;
  margin: 10px 0;
  display: flex; 
  justify-content: center;
  align-items: center;
}

.beforeToday .free,
.beforeToday .booked,
.beforeToday .full{
  display: none; 
}

.beforeToday,
.beforeToday:hover {
  background-color: #f7f7f7 !important;
  border: 1px solid rgb(200, 200, 200);
  margin: 10px 10px;
  cursor: default;
}

.beforeToday:hover span {
  color: #777777 !important
}

.free {
  background-color: #ebffe5;
}

.booked {
  background-color: #e5f2ff;
}

.full {
  background-color: #ffe5e5;
}

.hiddenInDestopView {
  display: none;
}

@media screen and (max-width:805px) {
  #calendar-grid {
    grid: auto-flow / 1fr;
  }
  .weekday-name {
    display: none;
  }
  .beforeToday {
    display: none;
  }
  .day-div>span {
    position: relative;
    display: block;
    top: 6px;
    left: 10px;
    font-weight: 500;
    width: 100%;
    text-align: left;
  }
  .hiddenInDestopView {
    display: inline-block;
  }
  .time-button {
    width: 100%;
    height: 60px;
    margin: 10px 0;
  }
  .hiddenInMobileView {
    display: none;
  }
}
#shade2 {
  position: fixed;
  z-index: 500;
  width: 100vw;
  height: 100vh;
  background-color: rgb(255, 255, 255);
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>